import { useEffect, useState } from "react";
import {
  getReportAllCourses,
  getReportAllStudents,
  getReportCoursesByParams,
  getReportProgramByParams,
  getReportStudentsByParams,
} from "../../services/reports.service";
import { ISelect } from "./utils";
import { ICourseReportData } from "../../interfaces/reports-courses.interface";
import { IProgramReportResponse } from "../../interfaces/reports-program.interface";

export function useBuildReport(type: string, params: any) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [programReport, setProgramReport] = useState<IProgramReportResponse>();
  const [coursesReport, setCoursesReport] = useState<ICourseReportData>();
  const [studentsReport, setStudentsReport] = useState<any>();
  const [allCourses, setAllCourses] = useState<ISelect[]>();
  const [allStudents, setAllStudents] =
    useState<{ id: Number; value: string }[]>();

  const getReportData = async () => {
    if (type === "Program")
      setProgramReport(await getReportProgramByParams(String(1), params));
    else if (type === "Course" && params?.courses?.length)
      setCoursesReport(await getReportCoursesByParams(params));
    else if (type === "Student" && params?.student)
      setStudentsReport(await getReportStudentsByParams(params.student));
    setIsLoading(false);
  };

  const getAllCourses = async () => {
    setAllCourses(await getReportAllCourses());
  };

  const getAllStudents = async () => {
    setAllStudents(await getReportAllStudents());
  };

  useEffect(() => {
    setIsLoading(true);
    getReportData();
    getAllCourses();
    getAllStudents();
  }, []);

  useEffect(() => {
    setIsLoading(true);
    getReportData();
  }, [type, params]);

  return {
    isLoading,
    allCourses,
    allStudents,
    programReport,
    coursesReport,
    studentsReport,
  };
}
